module.exports = __webpack_public_path__ + "img/kong.78276ca7.png";